import { render, staticRenderFns } from "./ResultMy.vue?vue&type=template&id=72d26cca&scoped=true&"
import script from "./ResultMy.vue?vue&type=script&lang=js&"
export * from "./ResultMy.vue?vue&type=script&lang=js&"
import style0 from "./ResultMy.vue?vue&type=style&index=0&id=72d26cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d26cca",
  null
  
)

export default component.exports